export default "__VITE_ASSET__BE18xiyW__"